import { ChevronDownIcon } from '@air/design-icons';
import { Button } from '@air/primitive-button';
import { Popover, type PopoverProps } from '@air/primitive-popover';

export type LibraryAdvancedSettingsCustomFieldsPopoverProps = Pick<PopoverProps, 'children' | 'onOpenChange'> & {
  isOpen: PopoverProps['open'];
  label: string;
};

export const LibraryAdvancedSettingsCustomFieldsPopover = ({
  children,
  isOpen,
  label = 'Show all',
  onOpenChange,
}: LibraryAdvancedSettingsCustomFieldsPopoverProps) => {
  return (
    <Popover
      className="w-[var(--radix-popover-trigger-width)] p-0"
      open={isOpen}
      onOpenChange={onOpenChange}
      trigger={
        <Button
          appearance="outline"
          className="w-full justify-between gap-1"
          color="gray"
          size="medium"
          suffix={<ChevronDownIcon size="sm" />}
        >
          {label}
        </Button>
      }
    >
      {children}
    </Popover>
  );
};
